<template>
	<el-dialog 
		:lang="$i18n.locale" 
		:title="$t('ksaWhFBXOrderPage.newLabelFileInfo')" 
		:visible.sync="popup" 
		width="550px" 
        @close="handleCloseDialog"
		append-to-body
	>
		<el-table :data="newLabelTableData" style="width: 100%" border>
			<el-table-column type="index" width="55" align="center" />
			<el-table-column 
				prop="newLabelLink" 
				:label="$t('commonInfo.link')" 
				align="center" 
				:show-overflow-tooltip="true"
				style="padding-left:10px"
			>
				<template slot-scope="{row}">
					<a :href="row.newLabelLink" target="_blank" style="color:#01AAED">{{row.newLabelLink}}</a>
				</template>
			</el-table-column>
		</el-table>
        <div slot="footer" class="dialog-footer">
		<el-button @click="handleCloseDialog">{{$t('commonInfo.dialogBtnCancel')}}</el-button>
	</div>
	</el-dialog>
</template>

<script>
export default {
	name: 'DownloadNewLabel',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		labelLinks: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
            popup:false,
			newLabelTableData: []
		};
	},
	watch: {
		visible(val) {
			if (val) {
                this.popup = val;
				this.newLabelTableData = this.labelLinks;
			}
		},
	},
    methods: {
    handleCloseDialog() {
      this.popup = false; 
      this.$parent.newLabelPopup = false;
    }
  }
};
</script>

<style scoped>
/* 阿拉伯语样式 */
[lang="ar"] {
	::v-deep .el-dialog__headerbtn{
		right: auto;
		left: 20px;
	}
	::v-deep .el-dialog__footer {
		text-align: left;
		.el-button {
			margin: 0 10px;
		}
	}
}
</style>